module.exports = __webpack_public_path__ + "static/media/a3_05.e071c010.jpg";